module.exports = __webpack_public_path__ + "img/tim_80x80.44bf13a7.png";